import { call, put, takeLatest } from 'redux-saga/effects'

import {
  postBreeder,
  putBreeder,
  postCultivar,
  putCultivar,
  deleteCultivar
} from '@galo-monitor/services/apis/galoMonitorApi/resources/cultivar'

import { CultivarActions, CultivarTypes } from './duckCultivar'

function* saveBreeder({ breeder, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(breeder.id ? putBreeder : postBreeder , breeder)
    yield call(onSuccess)
  } catch (err) {
    yield put(CultivarActions.cultivarError(err.message))
    yield call(onError, err)
  }
}

function* saveCultivar({ cultivar, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(cultivar.id ? putCultivar : postCultivar , cultivar)
    yield call(onSuccess)
  } catch (err) {
    yield put(CultivarActions.cultivarError(err.message))
    yield call(onError, err)
  }
}

function* removeCultivar({ cultivar, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteCultivar, cultivar)
    yield call(onSuccess)
  } catch (err) {
    yield put(CultivarActions.cultivarError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(CultivarTypes.SAVE_BREEDER, saveBreeder),
  takeLatest(CultivarTypes.SAVE_CULTIVAR, saveCultivar),
  takeLatest(CultivarTypes.REMOVE_CULTIVAR, removeCultivar)
]
